import ModelWithFacilityApi from "./ModelWithFacilityApi";

export default class MeteringTariffApi extends ModelWithFacilityApi {
	constructor(token, clientId, onUnauthorized) {
		super(token, clientId, onUnauthorized);
		this.baseUrl = this.getBaseUrl() + "metering/tariffs/";
	}
}
